import { Box } from '@chakra-ui/react';
import ScrollingText from 'components/NowPlaying/ScrollingText';
import useNowPlaying from 'hooks/use-now-playing';
import NowPlayingDetailContainer from './Container';

const NowPlayingDetail = () => {
  const { songName, singer } = useNowPlaying();
  return (
    <NowPlayingDetailContainer isSingleLine={!singer}>
      <Box w="100%" minW={0} px={4}>
        <ScrollingText color="#d2683b" fontWeight="bold" fontSize="lg" speed={15}>
          {songName}
        </ScrollingText>
        {singer && (
          <ScrollingText color="#d2683b" fontSize="xs" fontWeight="semibold" speed={15}>
            {singer}
          </ScrollingText>
        )}
      </Box>
    </NowPlayingDetailContainer>
  );
};

export default NowPlayingDetail;
